import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "40",
      height: "40",
      x: "1",
      y: "1",
      fill: "#EAF3FE",
      stroke: "#4893F4",
      "stroke-dasharray": "4 1.72",
      rx: "20"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M19 15c-.67-3.127-5.33-3.136-6 0-.393 1.835 1.062 3.033 2 4 .687.696 1.313.696 2 0 .938-.967 2.385-2.165 2-4m-3 2c-.46 0-1-.503-1-1s.54-1 1-1c.47 0 1 .503 1 1s-.53 1-1 1m14 8c-.666-3.127-5.325-3.136-6 0-.392 1.835 1.058 3.033 2 4 .683.696 1.317.696 2 0 .942-.967 2.392-2.165 2-4m-3 2c-.458 0-1-.503-1-1s.542-1 1-1c.459 0 1 .503 1 1s-.541 1-1 1"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M22 29h-2c-1.043 0-2.64-1.024-3-2-.369-.976.218-1.305 1-2l7-7c.432-.38 1.126-.648 1-1-.135-.352-1.424-1-2-1h-2c-.369 0-1 .37-1 0s.631-1 1-1h2c1.043 0 2.64 1.024 3 2 .369.976-.217 1.305-1 2l-7 7c-.431.38-1.126.648-1 1 .135.352 1.425 1 2 1h2c.369 0 1-.37 1 0s-.631 1-1 1"
    }, null, -1)
  ]))]))
}
export default { render: render }